import {
  SIGNUP_SUBMITTED,
  SIGNUP_SUCCESS,
  SIGNOUT_SUCCESS,
  SIGNUP_ERROR,
  LOGIN_ERROR,
  LOGIN_SUCCESS
} from '../constants';

const initState = {
  authError: null,
  processingSignup: false
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case LOGIN_ERROR:
      return {
        ...state,
        authError: 'Login failed'
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        authError: null
      };

    case SIGNOUT_SUCCESS:
      return state;

    case SIGNUP_SUBMITTED:
      return {
        ...state,
        processingSignup: true
      };

    case SIGNUP_SUCCESS:
      return {
        ...state,
        authError: null,
        processingSignup: false
      };

    case SIGNUP_ERROR:
      return {
        ...state,
        authError: action.err.message,
        processingSignup: false
      };

    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.js